import PublicStep from './PublicStep.component';

export default PublicStep;
